import React, { Component } from 'react'
import numeral from "numeral";
import * as d3 from "d3";
import tooltip from "./Tooltip.js";
import utils from "./utils.js";
const customFormat = (value, format) => {
  if(typeof format === 'string'){
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value)
  }else{
    return value;
  }
}

export default class BarsChart extends Component {
  constructor(props) {
    super(props)

    // this.colorScale = scaleLinear()
    //   .domain([0, this.props.maxValue])
    //   .range(['#F3E5F5', '#7B1FA2'])
    //   .interpolate(interpolateLab)
  }
  componentDidUpdate(){
  }
  onColumnBarClick=(xAxisLabels,yAxisValue,name,oriDatum,xAxisPosition,xAxisScale,yAxisScale,tooltipStyle,height,margins,id,showColumnChartTooltip,datum)=>{
    var data={
      xAxisLabels:xAxisLabels,
      yAxisValue:yAxisValue,
      name:name,
      data: oriDatum
    };
    if(this.props.onColumnBarClick!=undefined && (oriDatum.enableClick==undefined || oriDatum.enableClick==true) ){
      hideDetail();
      this.props.hideColumnChartTooltip();
      this.props.onColumnBarClick(data,function(result){
        if(result.component && typeof(result.component)=='object'){
          showColumnChartTooltip(result.component,{x:xAxisPosition,bandwidth:xAxisScale.scale.bandwidth(),y:(yAxisScale.scale(datum)),tooltipStyle:tooltipStyle,barHeight:(height - margins.bottom - yAxisScale.scale(datum)),id:id,isDataTip:true});
        }
      });
    }
  }
  onBarMouseEnter=(tooltip,globalTooltip,mainDivId,margins,xAxisPosition,xAxisTooltipsLabel,datum,name,mouseEvent,globalTooltipData,tooltipStyle,tooltipPosition,xAxisScale,yAxisScale,id,showColumnChartTooltip,oriDatum,onColumnBarClick,fillColor,hoverStyle,height)=>{
    tooltip ? (tooltip===true || globalTooltip==true) ? 
          showDetail({id:mainDivId,margins:margins,tooltip:tooltip,x:xAxisPosition || {}},[{[name]:datum,name:xAxisTooltipsLabel}],mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition) :
          showColumnChartTooltip(tooltip ||'<g class="tooltipg"></g>',{x:xAxisPosition,bandwidth:xAxisScale.scale.bandwidth(),y:(yAxisScale.scale(datum)),tooltipStyle:tooltipStyle,barHeight:(height - margins.bottom - yAxisScale.scale(datum)),id:id}): '';
    
    if(hoverStyle!=undefined){
        if(hoverStyle.hasOwnProperty('labelStyle')==true){
          var textStyle='text-anchor:start;dominant-baseline:central;';
          var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
          var dataIndex=globalData["dataIndex"];
          d3.selectAll(".multiseries-bar-text_"+dataIndex).attr("style",utils.convertReactStyleToHtml(hoverStyle.labelStyle,textStyle));
        }
        if(hoverStyle.hasOwnProperty('barStyle')==true){
          var cursorStyle=onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum !=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
           : "default";
          var rectStyle='cursor:'+cursorStyle+';fill:'+((oriDatum !=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor)+';';
          mouseEvent.target.setAttribute("style",utils.convertReactStyleToHtml(hoverStyle.barStyle,rectStyle));
        }
    }
    if((oriDatum !=null && typeof(oriDatum)=='object')){
      if(oriDatum.hoverLabelStyle!=undefined && oriDatum.enableClick==true &&  typeof(oriDatum.hoverLabelStyle)=='object'){
        var textStyle='text-anchor:start;dominant-baseline:central;';
        var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
        var dataIndex=globalData["dataIndex"];
        d3.selectAll(".multiseries-bar-text_"+dataIndex).attr("style",utils.convertReactStyleToHtml(oriDatum.hoverLabelStyle,textStyle));
      }
      if(oriDatum.hoverBarStyle!=undefined && oriDatum.enableClick==true &&  typeof(oriDatum.hoverBarStyle)=='object'){
        var cursorStyle=onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum !=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
           : "default";
        var stroke=(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.stroke ? "transparent" : oriDatum.stroke) : "transparent";
        var strokeWidth=(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.strokeWidth ? "0px" : oriDatum.strokeWidth) : "0px";
        var rectStyle='cursor:'+cursorStyle+';fill:'+((oriDatum !=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor)+';stroke:'+stroke+";stroke-width:"+strokeWidth+";";
        mouseEvent.target.setAttribute("style",utils.convertReactStyleToHtml(oriDatum.hoverBarStyle,rectStyle));
      }
    }
    

  }
  onBarMouseOut=(tooltip,globalTooltip,hideColumnChartTooltip,mouseEvent,oriDatum,fillColor,onColumnBarClick,dataLabels,hoverStyle)=>{
    tooltip ? (tooltip===true || globalTooltip==true) ? hideDetail() :hideColumnChartTooltip() : '';
    if(hoverStyle!=undefined){
        if(hoverStyle.hasOwnProperty('labelStyle')==true){
          var textStyle='text-anchor:start;dominant-baseline:central;fill:#000;font-size:12px;font-weight:normal';
          var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
          var dataIndex=globalData["dataIndex"];
          d3.selectAll(".multiseries-bar-text_"+dataIndex).attr("style",utils.convertReactStyleToHtml(dataLabels && dataLabels.style ? dataLabels.style :{},textStyle));
        }
        if(hoverStyle.hasOwnProperty('barStyle')==true){
          var cursorStyle=onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum !=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
          : "default";
          var rectStyle='cursor:'+cursorStyle+';fill:'+((oriDatum !=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor)+';';
          mouseEvent.target.setAttribute("style",rectStyle);
        }
    }
    if((oriDatum !=null && typeof(oriDatum)=='object')){
      if(oriDatum.hoverLabelStyle!=undefined && oriDatum.enableClick==true &&  typeof(oriDatum.hoverLabelStyle)=='object'){
        var textStyle='text-anchor:start;dominant-baseline:central;fill:#000;font-size:12px;font-weight:normal';
        var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
        var dataIndex=globalData["dataIndex"];
        d3.selectAll(".multiseries-bar-text_"+dataIndex).attr("style",utils.convertReactStyleToHtml(dataLabels && dataLabels.style ? dataLabels.style :{},textStyle));
      }
      if(oriDatum.hoverBarStyle!=undefined && oriDatum.enableClick==true &&  typeof(oriDatum.hoverBarStyle)=='object'){
        var cursorStyle=onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum !=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
           : "default";
        var stroke=(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.stroke ? "transparent" : oriDatum.stroke) : "transparent";
        var strokeWidth=(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.strokeWidth ? "0px" : oriDatum.strokeWidth) : "0px";
        var rectStyle='cursor:'+cursorStyle+';fill:'+((oriDatum !=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor)+';stroke:'+stroke+";stroke-width:"+strokeWidth+";";
        mouseEvent.target.setAttribute("style",rectStyle);
      }
    }
  }
  render() {
    var that=this;
    const { yAxisScale,xAxisScale, margins, data, svgDimensions,fillColor,isGroupBar,groupIndex,mainGroupIndex,xAxisData,dataLabels,tooltip,id,name,mainDivId,
            showColumnChartTooltip,hideColumnChartTooltip,globalTooltip,globalTooltipData,tooltipStyle,primaryXAxis,tooltipPosition,hoverStyle } = this.props;
    const xAxisCategory=(this.props.xAxisCategory!=null && typeof(this.props.xAxisCategory)=='object') ? this.props.xAxisCategory["data"] : this.props.xAxisCategory;
    const { height } = svgDimensions;
    var defaultDataLabelFormat=function(d){
      return d;
    };//"0,0.[00]"
    tooltipStyle.format= tooltipStyle.format!=undefined ? tooltipStyle.format : ((xAxisScale.labels && xAxisScale.labels.format) || defaultDataLabelFormat);
    tooltipStyle.prefix= tooltipStyle.prefix!=undefined ? tooltipStyle.prefix : ((xAxisScale.labels && xAxisScale.labels.prefix) || '');
    tooltipStyle.postfix= tooltipStyle.postfix!=undefined ? tooltipStyle.postfix : ((xAxisScale.labels && xAxisScale.labels.postfix) || '');
    const bars = 
      data.map(function(datum,index) {
        var oriDatum=datum;  
        if(datum!=null && typeof(datum)=='object'){
          oriDatum=$.extend({},false,(datum==null) ? {} : datum);
          datum=datum.data;
        }
        var xAxisLabels=isGroupBar ? ("groupDomain"+"_"+groupIndex) : ((xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index].data : xAxisData[index]);
        var xAxisTooltipsLabel=isGroupBar ? xAxisCategory : ((xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index].data : xAxisData[index]);
        var xAxisPosition=isGroupBar ? (primaryXAxis.scale(xAxisCategory)+(xAxisScale.scale(xAxisLabels))) :margins.left;
        var globalData={xAxisTooltipsLabel:xAxisTooltipsLabel,
          dataIndex:isGroupBar ? mainGroupIndex : index,
          xAxisPosition:xAxisPosition
        }
        //xAxisScale.scale(datum)
        return (<rect
          className={that.props.onColumnBarClick ? "multiseries-bar-blinkonMOver" :""}
          key={"data_"+index+"_"+xAxisLabels+"_"+name}
          x={margins.left}
          y={yAxisScale.scale(xAxisLabels) }
          height={(yAxisScale.scale.bandwidth()) }
          width={xAxisScale.scale(datum)-margins.left}
          fill={(oriDatum !=null && typeof(oriDatum)=='object') ?(oriDatum.fillColor==undefined ? fillColor : oriDatum.fillColor) : fillColor}
          style={{cursor:that.props.onColumnBarClick ?
            ((oriDatum!=null && typeof(oriDatum)!='object')) ? "pointer" :((oriDatum !=null && typeof(oriDatum)=='object') && (oriDatum.enableClick==undefined || oriDatum.enableClick==true)) ?"pointer":"default"
           : "default",
           stroke:(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.stroke ? "transparent" : oriDatum.stroke) : "transparent",
           strokeWidth:(oriDatum!=null && typeof(oriDatum)=='object') ? (oriDatum.strokeWidth ? "0px" : oriDatum.strokeWidth) : "0px"}}
          onClick={()=>{that.onColumnBarClick(xAxisTooltipsLabel,datum,name,((oriDatum !=null && typeof(oriDatum)=='object') ? oriDatum : {}),xAxisPosition,yAxisScale,xAxisScale,tooltipStyle,height,margins,id,showColumnChartTooltip,datum)}}
          data={JSON.stringify(globalData)}
          onMouseEnter={(mouseEvent,index)=>{that.onBarMouseEnter(tooltip,globalTooltip,mainDivId,margins,xAxisPosition,xAxisTooltipsLabel,datum,name,mouseEvent,globalTooltipData,tooltipStyle,tooltipPosition,xAxisScale,yAxisScale,id,showColumnChartTooltip,oriDatum,that.props.onColumnBarClick,fillColor,hoverStyle,height)}}
          onMouseOut={(mouseEvent,index)=>{
            that.onBarMouseOut(tooltip,globalTooltip,hideColumnChartTooltip,mouseEvent,oriDatum,fillColor,that.props.onColumnBarClick,dataLabels,hoverStyle);
          }}
          onMouseMove={(mouseEvent,index)=>{tooltip ? ((tooltip===true || globalTooltip==true) && tooltipPosition.toLowerCase()=='cursor') ? 
          showDetail({id:mainDivId,margins:margins,tooltip:tooltip,x:xAxisPosition || {}},[{[name]:datum,name:xAxisTooltipsLabel}],mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition):'' : ''}}
        />)
      });
    
    var format=dataLabels.format || (yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat;
    var prefix=dataLabels.prefix || (yAxisScale.labels && yAxisScale.labels.prefix) || "";
    var postfix=dataLabels.postfix || (yAxisScale.labels && yAxisScale.labels.postfix) || "";
    const text = 
      data.map(function(datum,index) {
      var oriDatum=datum;  
      if(datum!=null && typeof(datum)=='object'){
        oriDatum=$.extend({},false,(datum==null) ? {} : datum);
        datum=datum.data;
      }
      var xAxisLabels=isGroupBar ? ("groupDomain"+"_"+groupIndex) : ((xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index].data : xAxisData[index]);
        return (<text
          key={index}
          x={xAxisScale.scale(datum)+5}
          y={yAxisScale.scale(xAxisLabels)+(yAxisScale.scale.bandwidth()/2)}
          fill={'#000'}
          className={"multiseries-originalbar-text_"+index+" multiseries-originalbar-dataLabels"}
          style={$.extend({'textAnchor':'start','fontSize':"12px",fontWeight:'normal','dominantBaseline':'central'},false,(dataLabels && dataLabels.style ? dataLabels.style :{}))}
        >{prefix+""+customFormat(datum,format)+""+postfix}</text>)
      });
    return (
      <g>{bars}{(dataLabels && dataLabels.enabled==true) && text}
          { React.Children.count(this.props.children) ? 
            <g className="columnBarChildComponent">
              { React.Children.map(this.props.children,function(child,index){
                  return (<g key={index}  className="columnBarChildComponent">{child}</g>);
                })
              }
            </g> 
            : null
          }  
      </g>
    )
  }
 
}

export function showDetail(props, data, mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition) {
  var labelFontSize =tooltipStyle.labelFontSize ||  "12px";
  var labelFontColor =tooltipStyle.labelFontColor ||  "black";
  var labelFontFamily = tooltipStyle.labelFontFamily ||  "";
  var valueFontSize =tooltipStyle.valueFontSize ||  "12px";
  var valueFontColor =tooltipStyle.valueFontColor ||  "black";
  var valueFontFamily =tooltipStyle.valueFontFamily ||  "";
  if(props.tooltip===true){
    var x=props.x+(parseFloat(d3.select(mouseEvent.target).attr("width"))/2);
    var y=parseFloat(d3.select(mouseEvent.target).attr("y"));
    var defaultDataLabelFormat=function(d){
      return d;
    };//"0,0.[00]"
    var format=tooltipStyle.format || defaultDataLabelFormat;
    var prefix=tooltipStyle.prefix || '';
    var postfix=tooltipStyle.postfix || '';
    data.map(function(d) {
      var content = `<tr>
          <td colspan="2" class="value"  style="text-align: center;letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
        d["name"]
      }</td></tr>`;
      delete d.name;
      var tooltipsContents = Object.keys(d);
      tooltipsContents.map(function(data) {
        content =
          content +
          `<tr><td class="key" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${labelFontSize};font-family:${labelFontFamily};color:${labelFontColor}">${data} </td>
              <td class="value" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
                prefix +customFormat(d[data],format)+postfix
          }</td></tr>`;
      });
  
      d["content"] = content;
      d["x"] = (tooltipPosition=="cursor") ? mouseEvent.clientX : x+ $("#" + props.id).offset().left;//d3.event.x;
      d["y"] = (tooltipPosition=="cursor") ? mouseEvent.clientY : y+ $("#" + props.id).offset().top+10;// d3.event.y;
      d["mainDivId"] = props.id;
      d["marginLeft"] = props.margins.left;
      d["marginTop"] = props.margins.top;
    });
    tooltip.showTooltip(data, d3.event, "tooltip_map",(tooltipPosition=="cursor") ?  true :false,globalTooltip);
  }else{
  }  
  
}

export function hideDetail(d) {
  tooltip.hideTooltip();
}
